import type { ReactNode } from "react";
import { useCallback } from "react";

import type { FormatStrings } from "@skilitics/localization";
import { useFormatMessage } from "@skilitics/localization";

import { useSidebar } from "../SidebarContext";
import {
  SidebarSectionCloseButton,
  SidebarSectionContainer,
  SidebarSectionContent,
  SidebarSectionDescription,
  SidebarSectionHeader,
  SidebarSectionHeading,
  SidebarSectionTitle,
} from "./shared";

type Props = {
  formatStrings: {
    title: FormatStrings;
    description: FormatStrings;
  };
  children: ReactNode;
};

export const SidebarSection = ({ formatStrings, children }: Props) => {
  const formatMessage = useFormatMessage(formatStrings);
  const { main, popOut } = useSidebar();

  const handleClose = useCallback(() => {
    popOut.closePanel();
    main.closePanel();
  }, [main, popOut]);

  return (
    <SidebarSectionContainer>
      <SidebarSectionHeader data-test="panel-header">
        <SidebarSectionTitle>
          <SidebarSectionCloseButton icon="angle-left" onClick={handleClose} data-test="close-sidebar-button" />
          <SidebarSectionHeading>{formatMessage("title")}</SidebarSectionHeading>
        </SidebarSectionTitle>
        <SidebarSectionDescription>{formatMessage("description")}</SidebarSectionDescription>
      </SidebarSectionHeader>
      <SidebarSectionContent>{children}</SidebarSectionContent>
    </SidebarSectionContainer>
  );
};
